
import React from 'react';

export const DocumentTextIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    description
  </span>
);